// List of QoS to be filtered from payload if IP Proxy is enabled
export default [
  'audioLocalAddress',
  'audioRemoteAddress',
  'videoLocalAddress',
  'videoRemoteAddress',
];
